module.exports = "<app-main-nav>\n  <main>\n    <router-outlet></router-outlet>\n  </main>\n</app-main-nav>\n\n"